import { z } from 'zod';
export const SingleModelSchema = z.object({
    provider: z.enum(['anthropic', 'openai', 'qwick', 'mock', 'github', 'google']),
    model: z.string(),
    parameters: z.record(z.any()).optional(),
});
export const PreferredModelsSchema = z.array(SingleModelSchema).min(1);
export const ModelConfigSchema = z.union([
    z.object({
        model: SingleModelSchema
    }),
    z.object({
        preferred_models: PreferredModelsSchema
    })
]);
export const UsageLimitsSchema = z.object({
    max_input_tokens: z.number().positive().optional(),
    max_output_tokens: z.number().positive().optional(),
    max_cost_usd: z.number().positive().optional(),
    timeout_seconds: z.number().positive().optional(),
});
export const ToolsetConfigSchema = z.object({
    name: z.string(),
    tools: z.array(z.string()),
    enabled: z.boolean().default(true),
    configuration: z.record(z.any()).optional(),
});
export const AgentConfigSchema = z.object({
    name: z.string().regex(/^[a-zA-Z0-9_-]+$/),
    description: z.string().min(10),
    system_prompt: z.string().min(50),
    toolsets: z.array(ToolsetConfigSchema).optional(),
    usage_limits: UsageLimitsSchema.optional(),
    output_file: z.string().optional(),
    output_variable: z.string().optional(),
    metadata: z.record(z.any()).optional(),
}).and(ModelConfigSchema);
export function getPrimaryModel(config) {
    if ('model' in config) {
        return config.model;
    }
    else if ('preferred_models' in config) {
        return config.preferred_models[0];
    }
    throw new Error('Invalid ModelConfig format');
}
export function getFallbackModels(config) {
    if ('model' in config) {
        return [];
    }
    else if ('preferred_models' in config) {
        return config.preferred_models.slice(1);
    }
    return [];
}
export function createSingleModel(provider, model, parameters) {
    return {
        provider,
        model,
        parameters,
    };
}
export function createPreferredModels(...models) {
    if (models.length === 0) {
        throw new Error('At least one model is required');
    }
    return models;
}
//# sourceMappingURL=model-schemas.js.map